//IMPORT - UTILS
import { isJavascriptEnabled } from './utils/isJavascriptEnabled';
import { getFocusable } from './utils/getFocusable';
import { nextFocusable } from './utils/nextFocusable';
import { isPrintableChar } from './utils/isPrintableChar';
import { isInputable } from './utils/isInputable';
import { isSet } from './utils/isSet';

//IMPORT - FUNCTIONS
import { initEmblaCarousels } from "./functions/_emblaCarouselInit";

//IMPORT - CLASSES
import { Layer } from "./classes/Layer";
import { Accordion } from "./classes/Accordion";
import { Dropdown } from "./classes/Dropdown";
import { StickyHeader } from "./classes/StickyHeader";
import { ContentNav } from "./classes/ContentNav";

isJavascriptEnabled();

window.__TEST_SUCCESS__ = true;

const focusableElements = [
    'a[href]:not([disabled]):not([hidden]):not([aria-hidden])',
    'area[href]:not([disabled]):not([hidden]):not([aria-hidden])',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    'iframe:not([disabled]):not([hidden]):not([aria-hidden])',
    'object:not([disabled]):not([hidden]):not([aria-hidden])',
    'embed:not([disabled]):not([hidden]):not([aria-hidden])',
    '[contenteditable]:not([disabled]):not([hidden]):not([aria-hidden])',
    '[tabindex]'
];
window.focusableElements = focusableElements;

const store = {
    activeLayers: [],
    activeLayer: ''
};
window.store = store;

// CAROUSELS
initEmblaCarousels();

// STICKY MASTHEAD
/** @type {<Element>} */
const siteHeader = document.querySelector('.site-header.sticky--js');
if (isSet(siteHeader)) {
    const stickyHeader = new StickyHeader(siteHeader);
}


const panelAccordions = document.querySelectorAll(".accordion--panel-description-list--js");
panelAccordions.forEach(function (accordionElm) {
    new Accordion(
        accordionElm,
        {
            onAfterOpen: (object, event, item) => {
                const span = item.trigger.querySelector('span');
                if(isSet(span)) span.textContent = 'Show Less';
            },
            onAfterClose: (object, event, item) => {
                const span = item.trigger.querySelector('span');
                if(isSet(span)) span.textContent = 'Read More';
            },
            collapsible:true,
            type: 'multiple'
        }
    );
});

const caseStudyAccordions = document.querySelectorAll(".accordion--card--case-studies--js");
caseStudyAccordions.forEach(function (accordionElm) {
    new Accordion(
        accordionElm,
        {
            onAfterOpen: (object, event, item) => {
                item.trigger.querySelector('svg').remove();
                item.trigger.insertAdjacentHTML('beforeend', '<svg width="27" height="2" viewBox="0 0 27 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1H26" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
            },
            onAfterClose: (object, event, item) => {
                item.trigger.querySelector('svg').remove();
                item.trigger.insertAdjacentHTML('beforeend', '<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 13.5H26M13.5 1V26" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
            },
            collapsible:true,
            type: 'multiple'
        }
    );
});


function collapseAccordion(object, item, e){
    object.toggle(item); 
}
const iconCardAccordions = document.querySelectorAll(".accordion--card--icon--js");
iconCardAccordions.forEach(function (accordionElm) {
    let storedCollapseHandler = null;
    new Accordion(
        accordionElm,
        {
            onAfterOpen: (object, event, item) => {
                const collapseElm = item.panelContent.querySelector('.accordion-collapse--js');
                const collapseHandler = (e) => collapseAccordion(object, item, e);
                collapseElm.addEventListener("click", collapseHandler);
                storedCollapseHandler = collapseHandler;

                item.trigger.setAttribute('disabled', 'disabled');
                collapseElm.focus();
            },
            onAfterClose: (object, event, item) => {
                const collapseElm = item.panelContent.querySelector('.accordion-collapse--js');
                collapseElm.removeEventListener("click", storedCollapseHandler);

                item.trigger.removeAttribute('disabled');
                item.trigger.focus();
            },
            collapsible:true,
            type: 'multiple'
        }
    );
});



const componentAccordions = document.querySelectorAll(".accordion--component--js");
componentAccordions.forEach(function (accordionElm) {
    new Accordion(
        accordionElm,
        {
            onAfterOpen: (object, event, item) => {
            },
            onAfterClose: (object, event, item) => {
            },
            collapsible:true,
            type: 'single'
        }
    );
});


// CONTENT NAV
/** @type {NodeListOf<Element>} */
const floatingNavElm = document.querySelector('#floating-nav');
if (isSet(floatingNavElm)) {
    const floatingNav = new Dropdown(
        floatingNavElm,
        {
            closeOnItemClick: true,
            onAfterOpen: (object, event) => {
                object.trigger.querySelector('svg').remove();
                object.trigger.insertAdjacentHTML('beforeend', '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--we-white)"><path d="M256-213.85 213.85-256l224-224-224-224L256-746.15l224 224 224-224L746.15-704l-224 224 224 224L704-213.85l-224-224-224 224Z"/></svg>');
            },
            onAfterClose: (object, event) => {
                object.trigger.querySelector('svg').remove();
                object.trigger.insertAdjacentHTML('beforeend', '<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--we-white)"><path d="M140-302.31v-60h526.92v60H140ZM140-450v-60h526.92v60H140Zm0-147.69v-60h526.92v60H140ZM787.69-300q-13.73 0-23.02-9.18t-9.29-22.74q0-13.9 9.29-23.3t23.02-9.4q13.73 0 23.02 9.4t9.29 23.3q0 13.56-9.29 22.74-9.29 9.18-23.02 9.18Zm0-147.31q-13.73 0-23.02-9.19t-9.29-23.5q0-13.57 9.29-22.74 9.29-9.18 23.02-9.18t23.02 9.18Q820-493.57 820-480q0 14.31-9.29 23.5t-23.02 9.19Zm0-148.07q-13.73 0-23.02-9.18t-9.29-22.75q0-13.89 9.29-23.29 9.29-9.4 23.02-9.4t23.02 9.4q9.29 9.4 9.29 23.29 0 13.57-9.29 22.75t-23.02 9.18Z"/></svg>');
            },
        }
    );
}
const contentNav = new ContentNav();


//LAYERS
const layers = document.querySelectorAll(".component--layer--js");
layers.forEach(function (layerElm) {
    let layer = new Layer(
        layerElm,
        {
            awaitCloseAnimation: true,
            awaitOpenAnimation: true,
        }
    );
});